import { declareVueComponent, declareComponents} from '/vodalys/vvuejs'

// import components from './components/**/*.vue'
// declareComponents('components', components)


import ZapperTalktoOverlay from './components/ZapperTalktoOverlay.vue'
declareVueComponent('ZapperTalktoOverlay', ZapperTalktoOverlay)